/** Local +Z faces outward; the cylinder axis is radius units behind the panel centre. */
export function panelSurfacePoint(x, y, radius, bias = 0) {
    if (radius === undefined)
        return [x, y, bias];
    const angle = x / radius;
    return [(radius + bias) * Math.sin(angle), y, (radius + bias) * Math.cos(angle) - radius];
}
